export default __webpack_public_path__ + "static/media/system.98b53c01.svg";